module.exports = __webpack_public_path__ + "img/img-txtsentbe.dbaaf997.svg";